import { useCallback, useState } from 'react';
import { NoopType } from 'types/global';

export const useToggle = (initialState = false): [boolean, NoopType] => {
  const [state, setState] = useState(initialState);

  return [state, useCallback(() => setState((state) => !state), [])];
};
